<!--
    描述：评审项目信息
    日期：2022/12/1
    创建人：李家宝
-->
<template>
  <div class="box">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="项 目 登 记" name="1">
        <el-form label-width="150px" :show-message="false">
          <!--专家库使用单位信息-->
          <div class="zjxq_box">
            <div class="box_text">专家库使用单位信息</div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="使用单位名称："
                  >{{ busProjectObj.tenantName }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="社会统一信用代码："
                  >{{ busProjectObj.creditCode }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人：">{{
                  busProjectDetailsObj.contacter
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话：">{{
                  busProjectDetailsObj.contacterPhone
                }}</el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--项目信息-->
          <div class="zjxq_box">
            <div class="box_text" style="border-bottom: 0px">项目信息</div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="项目名称："
                  >{{ project.sname }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目类型：">{{
                  project.busTypeName
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预算金额："
                  >{{ busProjectDetailsObj.budget }}万元</el-form-item
                >
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目所在区域："
                  >{{ busProjectDetailsObj.proAreaName }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目详细地址："
                  >{{ busProjectDetailsObj.proAddress }}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="项目附件：">
                  <div class="beyondHiding">
                    <div
                        v-for="(item, index) in busProjectFilePss"
                        :key="index"
                        class="link mr10"
                        type="text"
                        @click="viewFile(item.fileDirectory + item.serverName, item.fileName)"
                    >
                      <span slot="reference">{{ item.fileName }}</span>
<!--                      <el-popover
                          placement="top-start"
                          title="文件"
                          trigger="hover"
                      >
                        <div
                            v-for="e in busProjectFiles"
                            class="link"
                            :key="e.id"
                            @click="viewFile(e.fileDirectory + e.serverName)"
                        >
                          {{ e.fileName }}
                        </div>
                        <span slot="reference">{{ item.fileName }}</span>
                      </el-popover>-->
                    </div>
                  </div>
<!--                  <my-upload
                    ref="cns"
                    :aid="project.baseId"
                    :maxNum="1"
                    assortment="bus_project_ps"
                    :tableName="'business_expand_zhuanjia'"
                    mode="view"
                    forDatabase="project_audit"
                    :isDisabled="true"
                  />-->
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--标段信息-->
          <div class="zjxq_box">
            <div class="box_text">评审信息</div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="评审地点："
                  >{{ busProjectObj.areaName }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="评标详细地址："
                  >{{ busProjectObj.bidAddress }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="评审时间："
                  >{{ project.openTime }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="评审类型：">{{
                  busProjectObj.reviewTypeName
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="计划抽取人数："
                  >{{ busProjectObj.extractNum }}人</el-form-item
                >
              </el-col>
            </el-row>
          </div>
          <!--建设单位信息-->
          <div class="zjxq_box">
            <div class="box_text">建设单位信息</div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="建设单位名称："
                  >{{ busProjectDetailsObj.consUnit }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="社会统一信用代码："
                  >{{ busProjectDetailsObj.consCode }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="项目负责人：">{{
                  busProjectDetailsObj.consPrincipal
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话："
                  >{{ busProjectDetailsObj.consPhone }}
                </el-form-item>
              </el-col>
              <!--<el-col :span="12">-->
              <!--  <el-form-item label="备注：">{{-->
              <!--    busProjectDetailsObj.consRemark-->
              <!--  }}</el-form-item>-->
              <!--</el-col>-->
            </el-row>
          </div>
          <!--  设计单位信息-->
          <div class="zjxq_box">
            <div class="box_text">设计单位信息</div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="设计单位名称："
                  >{{ busProjectDetailsObj.designUnit }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="社会统一信用代码："
                  >{{ busProjectDetailsObj.designCode }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="负责人姓名：">{{
                  busProjectDetailsObj.designPrincipal
                }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="负责人联系电话：">{{
                  busProjectDetailsObj.designPhone
                }}</el-form-item>
              </el-col>

              <!--<el-col :span="12">-->
              <!--  <el-form-item label="备注：">{{-->
              <!--    busProjectDetailsObj.designRemark-->
              <!--  }}</el-form-item>-->
              <!--</el-col>-->
            </el-row>
          </div>
          <!--  项目复评-->
          <div class="zjxq_box" v-if="project.projectReviewObj != null">
            <div class="box_text">项目复评</div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="复评原因："
                  >{{ JSON.parse(project.projectReviewObj).judgeReason }}
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div class="zjxq_box" v-if="!isAudit" style="border: 1px solid #016CA4">
          <el-row>
            <el-col :span="8"> 创建人：{{ project.createUserName }} </el-col>
            <el-col :span="8"> 创建时间：{{ project.createDate }} </el-col>
            <el-col :span="8"> 抽取专家库：{{ project.libName }} </el-col>
          </el-row>
        </div>
        <div>
          <img
            v-if="project.status == '1009001004'"
            src="../../../../assets/images/project_end.png"
            alt="项目结束"
            title="项目结束"
            class="img"
          />
          <img
            src="../../../../assets/images/extracting.jpg"
            alt="待抽取"
            title="待抽取"
            v-if="project.status == '1009001003'"
            class="img"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import VUE_CONFIG from "../../../../../vue.config";

export default {
  name: "review-pro-beseinfo",
  props: {
    isAudit: {
      default: false
    },
    rowData: {
      type: Object
    },
    audit: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activeNames: ["1"],
      project: {},
      busProjectDetailsObj: {}, // 项目明细
      busProjectObj: {}, // 项目信息
      busProjectBidObj: [], // 标段信息
      busProjectFilePss: []
    }
  },
  created() {
    this.busProjectDetailsObj = this.rowData.busProjectDetailsObj
    this.busProjectObj = this.rowData.busProjectObj
    this.project = this.rowData
    this.busProjectBidObj = this.rowData.busProjectBidObj
    this.busProjectFilePss = this.rowData.sysFiles ? JSON.parse(this.rowData.sysFiles).filter(v => v.assortment == "bus_project_ps") : [];
  },
  methods: {
    // 查看文件
    viewFile(filePath, fileName) {
      let uploadUrl = "";
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }
      this.$previewFn(uploadUrl + filePath, fileName);
    },
  }
}
</script>

<style scoped lang="less">
/deep/ .el-collapse-item__header {
  background: #eff6fe;
  font-weight: bolder;
  padding-left: 10px;
}

.box {
  position: relative;
  height: 100%;

  .footer {
    position: fixed;
    top: 88px;
    right: 135px;

    .el-button {
      height: 28px !important;
    }
  }

  .tips-warning,
  .tips-error {
    color: #f4650f;
    display: flex;
    align-items: center;
    position: absolute;
    top: 14px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99;
  }

  .tips-error {
    color: red;
  }

  .img {
    position: absolute;
    width: 118px;
    height: 90px;
    top: 256px;
    right: 187px;
  }

  .zjxq_box {
    padding: 10px 20px;
    margin-bottom: 10px;

    .box_text {
      font-weight: 500;
      border-bottom: 1px solid #f5f5f5;
      height: 30px;

      &:before {
        content: "";
        width: 3px;
        margin-right: 5px;
        height: 12px;
        background: #1f79ff;
        display: inline-block;
        vertical-align: central;
      }
    }

    .zjxq_box_item {
      display: inline-block;
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #f2f2f2;
      padding: 0 5px;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>
